var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCerrarError40X40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5303 13.4697C26.8232 13.7626 26.8232 14.2374 26.5303 14.5303L14.5303 26.5303C14.2374 26.8232 13.7626 26.8232 13.4697 26.5303C13.1768 26.2374 13.1768 25.7626 13.4697 25.4697L25.4697 13.4697C25.7626 13.1768 26.2374 13.1768 26.5303 13.4697Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4697 13.4697C13.7626 13.1768 14.2374 13.1768 14.5303 13.4697L26.5303 25.4697C26.8232 25.7626 26.8232 26.2374 26.5303 26.5303C26.2374 26.8232 25.7626 26.8232 25.4697 26.5303L13.4697 14.5303C13.1768 14.2374 13.1768 13.7626 13.4697 13.4697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrarError40X40);
export default __webpack_public_path__ + "static/media/CERRAR-ERROR_40X40.f09cafec6a4929bc84dc93ca03847b5b.svg";
export { ForwardRef as ReactComponent };